//Libraries
import { BcodeSDKV1 } from "./v1";
import { BcodeSDKLegacy } from "./legacy";

//Types
import { SdkOptions, SdkV1Options } from "./types";

import * as Hash from "./modules/hash";
import * as QRCode from "./modules/qrcode";

class BcodeSDK {
  public version: string;
  public sdk: any;

  public constructor(sdkOptions: SdkOptions | SdkV1Options) {
    this.version = sdkOptions.version || "v0";

    if (this.version === "v1") {
      this.sdk = new BcodeSDKV1(sdkOptions as SdkV1Options) as BcodeSDKV1; // V1
    } else {
      this.sdk = new BcodeSDKLegacy(sdkOptions as SdkOptions) as BcodeSDKLegacy; //LEGACY
    }
  }

  public static create(sdkOptions: SdkV1Options): BcodeSDKV1 {
    const version = sdkOptions.version;

    if (version === "v1") {
      return new BcodeSDKV1(sdkOptions as SdkV1Options); // V1
    }
    throw "This function is available only for SDK V1";
  }

  public static createLegacy(sdkOptions: SdkOptions): BcodeSDKLegacy {
    const version = sdkOptions.version || "v0";

    if (version === "v0") {
      return new BcodeSDKLegacy(sdkOptions as SdkOptions); // Legacy
    }
    throw "This function is available only for Legacy SDK";
  }
}

export { Hash, QRCode, BcodeSDK, BcodeSDKLegacy, BcodeSDKV1 };
export * from "./types";
